import { render, staticRenderFns } from "./WaittingTab.vue?vue&type=template&id=05e64632"
import script from "./WaittingTab.vue?vue&type=script&lang=js"
export * from "./WaittingTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports